<template>
  <el-dialog
    title="选择商品"
    :visible.sync="dialogVisible"
    width="80%"
    top="5vh"
  >
    <div class="filter-container">
      <el-input
        v-model="searchQuery"
        placeholder="输入商品信息名称"
        style="width: 300px;"
        clearable
        @keyup.enter.native="handleFilter"
      />
      <el-button 
        type="primary" 
        icon="el-icon-search" 
        @click="handleFilter"
      >
        查询
      </el-button>
    </div>

    <el-table
      :data="products"
      border
      style="width: 100%; margin-top: 20px;"
    >
      <el-table-column prop="productId" label="商品编号" align="center" />
      <el-table-column prop="categoryName" label="商品大类" align="center" />
      <el-table-column label="商品图片" align="center">
        <template slot-scope="scope">
          <el-image
            style="width: 60px; height: 60px; border-radius: 5px;"
            :src="scope.row.coverPhoto"
            fit="cover"
          />
        </template>
      </el-table-column>
      <el-table-column prop="prodName" label="商品名称" align="center" />
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="handleChoose(scope.row)"
          >
            选择
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>
  </el-dialog>
</template>

<script>
import { queryProduct } from '@/api/goods/groupBuyProductApi'

export default {
  name: 'ChooseProduct',
  data() {
    return {
      dialogVisible: false,
      products: [],
      searchQuery: '',
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.currentPage = 1
      this.getProducts()
    },
    async getProducts() {
      try {
        const params = {
          page: this.currentPage,
          row: this.pageSize,
          prodNameLike: this.searchQuery
        }
        const res = await queryProduct(params)
        this.products = res.data
        this.total = res.total
      } catch (error) {
        console.error('获取商品列表失败:', error)
      }
    },
    handleFilter() {
      this.currentPage = 1
      this.getProducts()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getProducts()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getProducts()
    },
    handleChoose(product) {
      this.$emit('choose', product)
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>